var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"link-item"},[(_vm.isDisabled)?_c('a',{class:(_vm.isDark? 'dark' : '') + (_vm.isUnderlined? ' underlined' : '')},[_vm._t("default")],2):_c('a',{class:(_vm.isDark? 'dark' : '') + (_vm.isUnderlined? ' underlined' : ''),attrs:{"uk-toggle":_vm.toggle}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }